<!--
  Inline content: text runs with marks, and the four chip kinds the schema can
  put inside a paragraph. A node type this build has not heard of renders as
  nothing, which is what the old renderer did and is the right answer for a
  reader: a half-understood chip is worse than a gap.

  A chip carries `data-len`, its length in the text the server matches against
  (`@label` for a mention, which is not what it displays when the label is
  missing), so a selection that crosses one maps to the right characters. When
  a comment highlight covers it, it says so with a class and the thread ids.
-->
<script lang="ts">
  import type { PMNode } from '../types'
  import type { Cover } from '../anchors'
  import { inlineLength } from '../anchors'
  import Marked from './Marked.svelte'

  let { node, cover = null }: { node: PMNode; cover?: Cover | null } = $props()

  const len = $derived(node.type === 'text' ? 0 : inlineLength(node))
  const threads = $derived(cover ? cover.threads.join(' ') : undefined)
</script>

{#if node.type === 'text'}<Marked marks={node.marks ?? []} index={(node.marks ?? []).length - 1} text={node.text ?? ''} {cover} />{:else if node.type === 'mention'}<span class="chip mention" class:anchored={!!cover} data-len={len} data-threads={threads}>@{node.attrs?.label ?? 'you'}</span>{:else if node.type === 'date'}<span class="chip" class:anchored={!!cover} data-len={len} data-threads={threads}>{node.attrs?.value ?? ''}</span>{:else if node.type === 'dropdown'}<span class="chip" class:anchored={!!cover} data-len={len} data-threads={threads}>{node.attrs?.label ?? '—'}</span>{:else if node.type === 'embed'}<span class="chip" data-len={len}>chart</span>{/if}
